// @flow
import React, { Component } from "react";
import Breach from "../components/Breach/Breach";

type Props = {
  data: {
    prismicBreach: PrismicBreach
  }
};

class BreachTemplate extends Component<Props, void> {
  render() {
    const { data } = this.props;
    return <Breach breach={data.prismicBreach} />;
  }
}

export default BreachTemplate;

export const pageQuery = graphql`
  query BreachBySlug($uid: String!) {
    prismicBreach(uid: { eq: $uid }) {
      uid
      data {
        title {
          html
          text
        }
        company_name
        company_url {
          url
        }
        source_url {
          url
        }
        location {
          latitude
          longitude
        }
        parties_involved {
          name
          url {
            url
          }
        }
        severity
        disclosed_at
        discovered_at
        leaked_information
        attack_vector
        tags {
          tag
        }
        stories {
          url {
            url
          }
          published
          story_title
          description
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/breach.js